import { createStore } from 'vuex';
import _ from 'lodash';

export default createStore({
	state: {
		viewportScale: 1,
		viewportCoords: [0, 0],

		screen: 'home',

		selectedVidek: null,
		drawerOpen: false,
		interventions: [],
		dropSpots: [],
		endVideos: [],
		placedInterventions: [],
		selectedDropSpot: null,

		isDragging: false,
		inDrag: false,
		dragIntervention: null,
		startDragCoords: [0,0],
		dragCoords: [0,0],
		acceptingDropSpot: null,
	},
	mutations: {
		setViewportScale(state, scale){
			state.viewportScale = scale;
		},
		setViewportCoords(state, coords){
			state.viewportCoords = coords;
		},

		setScreen(state, screen){
			state.screen = screen;
		},

		setSelectedVidek(state, videk){
			state.selectedVidek = videk;
		},
		setDrawerOpen(state, open){
			state.drawerOpen = open;
		},
		setInterventions(state, interventions){
			state.interventions = interventions;
		},
		setDropSpots(state, dropSpots){
			state.dropSpots = dropSpots;
		},
		setEndVideos(state, endVideos){
			state.endVideos = endVideos;
		},
		setSelectedDropSpot(state, dropSpot){
			state.selectedDropSpot = dropSpot;
		},

		setIsDragging(state, isDragging){
			state.isDragging = isDragging;
		},
		setInDrag(state, inDrag){
			state.inDrag = inDrag;
		},
		setDragIntervention(state, intervention){
			state.dragIntervention = intervention;
		},
		setDragCoords(state, coords){
			state.dragCoords = coords;
		},
		setStartDragCoords(state, coords){
			state.startDragCoords = coords;
		},
		setAcceptingDropSpot(state, dropSpot){
			state.acceptingDropSpot = dropSpot;
		},
		setPlacedInterventions(state, interventions){
			state.placedInterventions = interventions;
		},
		placeIntervention(state, payload){
			state.placedInterventions.push(payload);
		},
	},
	actions: {
		setViewportScale(context, scale){
			context.commit('setViewportScale', scale);
		},
		setViewportCoords(context, coords){
			context.commit('setViewportCoords', coords);
		},

		setScreen(context, screen){
			context.commit('setScreen', screen);
		},

		resetGame(context){
			context.commit('setSelectedVidek', null);
			context.commit('setDrawerOpen', false);
			context.commit('setInterventions', []);
			context.commit('setDropSpots', []);
			//context.commit('setEndVideos', []);
			context.commit('setPlacedInterventions', []);
		},

		setSelectedVidek(context, videk){
			context.dispatch('resetGame');
			context.commit('setSelectedVidek', videk);
		},
		setDrawerOpen(context, open){
			context.commit('setDrawerOpen', open);
		},
		setInterventions(context, interventions){
			context.commit('setInterventions', interventions);
		},
		setDropSpots(context, dropSpots){
			context.commit('setDropSpots', dropSpots);
		},
		setEndVideos(context, endVideos){
			context.commit('setEndVideos', endVideos);
		},
		setSelectedDropSpot(context, dropSpot){
			context.commit('setSelectedDropSpot', dropSpot);
		},

		startDrag(context, payload){
			const localCoords = context.getters['localCoords'](payload.coords);

			context.commit('setIsDragging', true);
			context.commit('setDragIntervention', payload.intervention);
			context.commit('setStartDragCoords', localCoords);
			context.commit('setDragCoords', localCoords);
		},
		stopDrag(context){
			if(context.getters['inDrag'] && context.getters['acceptingDropSpot']){
				context.dispatch('setSelectedDropSpot', null);

				context.commit('placeIntervention', {
					intervention: context.getters['dragIntervention'],
					dropSpot: context.getters['acceptingDropSpot'],
				});
			}

			context.dispatch('setDrawerOpen', true);

			//reset drag
			context.commit('setIsDragging', false);
			context.commit('setInDrag', false);
			context.commit('setDragIntervention', null);
			context.commit('setDragCoords', [0, 0]);
		},
		moveDrag(context, coords){
			const localCoords = context.getters['localCoords'](coords);
			context.commit('setDragCoords', localCoords);

			if(!context.getters['inDrag']){
				const trashold = 5;
				const xDiff = Math.abs(context.getters['startDragCoords'][0] - localCoords[0]);
				const yDiff = Math.abs(context.getters['startDragCoords'][1] - localCoords[1]);

				if(xDiff > trashold || yDiff > trashold){
					context.commit('setInDrag', true);
				}
			}
		},
		setAcceptingDropSpot(context, dropSpot){
			context.commit('setAcceptingDropSpot', dropSpot);
		},
		setPlacedInterventions(context, interventions){
			context.commit('setPlacedInterventions', interventions);
		},
		undoLastPlacedIntervention(context){
			let interventions = context.getters.placedInterventions;
			context.dispatch('setPlacedInterventions', _.dropRight(interventions, 1));
		},
		removePlacedIntervention(context, dropSpotId){
			let interventions = context.getters.placedInterventions;

			context.dispatch('setPlacedInterventions', _.filter(interventions, (iv) => iv.dropSpot.id !== dropSpotId));
		},
	},
	getters: {
		viewportScale(state){
			return state.viewportScale;
		},
		viewportCoords(state){
			return state.viewportCoords;
		},

		screen(state){
			return state.screen;
		},

		selectedVidek(state){
			return state.selectedVidek;
		},
		drawerOpen(state){
			return state.drawerOpen;
		},
		interventions(state){
			return state.interventions;
		},
		dropSpots(state){
			return state.dropSpots;
		},
		dropSpot(state){
			return (id) => {
				return _.find(state.dropSpots, (ds) => ds.id == id);
			};
		},
		endVideos(state){
			return state.endVideos;
		},

		isDragging(state){
			return state.isDragging;
		},
		inDrag(state){
			return state.inDrag;
		},
		dragIntervention(state){
			return state.dragIntervention;
		},
		dragCoords(state){
			return state.dragCoords;
		},
		startDragCoords(state){
			return state.startDragCoords;
		},
		localCoords(state, getters){
			return (coords, offset = true) => {
				let x = coords[0];
				let y = coords[1];

				if(offset){
					x = x - getters['viewportCoords'][0];
					y = y - getters['viewportCoords'][1];
				}

				return [
					x / getters['viewportScale'],
					y / getters['viewportScale'],
				];
			};
		},
		acceptingDropSpot(state){
			return state.acceptingDropSpot;
		},
		placedInterventions(state){
			return state.placedInterventions;
		},
		spotPlacedIntervention(state, getters){
			return (spotId) => {
				return _.find(getters['placedInterventions'], (p) => p.dropSpot.id === spotId);
			};
		},
		allSpotPlaced(state, getters){
			return getters['placedInterventions'].length >= getters['dropSpots'].length
		},
		selectedDropSpot(state){
			return state.selectedDropSpot;
		},
	},
	modules: {

	}
})
